import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { getBusinessTypePath, getServerURL } from './api';
export var getBusinessEmailServiceURL = function getBusinessEmailServiceURL(businessType, businessId) {
  return "".concat(getServerURL(), "businesses/").concat(getBusinessTypePath(businessType), "/").concat(businessId, "/email/");
};
export var cleanDomainName = function cleanDomainName(potentialDomain) {
  var sideHyphensRegex = /(^-+|-+$)/g;
  var consecutiveHyphens = /-+/g;
  var invalidChars = /[^a-zA-Z0-9-]/g;
  return potentialDomain.split('.').map(function (s) {
    return s.replaceAll(sideHyphensRegex, '').replaceAll(consecutiveHyphens, '-').replaceAll(invalidChars, '');
  }).join('.').toLowerCase();
};
export function extractMainHostnameFromDomain(domain) {
  var mainHostname = '';
  try {
    var url = new URL(domain);
    var domainParts = url.hostname.split('.');

    // url like: facebook.com
    if (domainParts.length === 2) {
      var _domainParts = _slicedToArray(domainParts, 1);
      mainHostname = _domainParts[0];
    }

    // url like: www.facebook.com
    if (domainParts.length === 3) {
      var _domainParts2 = _slicedToArray(domainParts, 2);
      mainHostname = _domainParts2[1];
    }
    // domains with root other than .com or with subdomains are not processed
  } catch (e) {
    // leave empty mainHostname
  }
  return mainHostname;
}
export function isUrl(inputString) {
  try {
    // eslint-disable-next-line no-new
    new URL(inputString);
    return true;
  } catch (error) {
    return false;
  }
}
export function addSlashPrefix(inputString) {
  return inputString.startsWith('/') ? inputString : "/".concat(inputString);
}